import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';

import { CompanyService } from '@app/shared/services/company.service';
import { environment } from '@environments/environment';
import { IFBPagedResponseHttp, IFBUserInterest } from '@interfaces';
import { UserManager } from '@app/shared/services/user-manager.service';

@Injectable({
  providedIn: 'root'
})
export class UserInterestResource {
  cachedUserInterest$: Observable<IFBPagedResponseHttp<IFBUserInterest>>;

  url = `https://${environment.API_BASE}/v1/companies/${this.companyService.data.id}/users/${this.userManager.data.id}/interests`;

  constructor(
    private companyService: CompanyService,
    private userManager: UserManager,
    private http: HttpClient
  ) {}

  getPage() {
    if (!this.cachedUserInterest$) {
      this.cachedUserInterest$ = this.http.get<IFBPagedResponseHttp<IFBUserInterest>>(this.url).pipe(shareReplay(1));
    }

    return this.cachedUserInterest$;
  }

  add(interest: IFBUserInterest) {
    return this.http.post<IFBUserInterest>(this.url, interest).pipe(tap(() => (this.cachedUserInterest$ = null)));
  }

  remove(id: string) {
    return this.http.delete<void>(`${this.url}/${id}`).pipe(tap(() => (this.cachedUserInterest$ = null)));
  }
}
